import React, { useState, useEffect } from "react";
import { Table, Modal, Container, Row, Col, Spinner } from "react-bootstrap";
import NoData from "../NoData";

function GridModal({
  show,
  onHide = () => {},
  title,
  data = [],
  setSelected,
  setSelectedValue,
  selected,
  hasImage = true,
  initialSearch = "",
  page,
  loading = false,
}) {
  const [debouncedSearch, setDebouncedSearch] = useState(initialSearch);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (page === "searchFilter") {
      setSelected(initialSearch);
      setDebouncedSearch(initialSearch);
    }
  }, [initialSearch, page]);

  useEffect(() => {
    setIsTyping(true);
    const handler = setTimeout(() => {
      setDebouncedSearch(selected);
      setIsTyping(false);
    }, 5000);

    return () => clearTimeout(handler);
  }, [selected]);

  const filteredData = data.filter((item) =>
    item.title.toLowerCase().includes(debouncedSearch.toLowerCase())
  );

  function onSelect(item) {
    setSelectedValue(item);
    setTimeout(() => {
      onHide();
    }, 500);
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="grid-example"
        style={{ maxHeight: "400px", overflowY: "auto" }}
      >
        <Container>
          <Row className="mb-3">
            <Col xs={12}>
              <input
                type="text"
                className="form-control"
                placeholder="Search Dealers..."
                value={selected}
                onChange={(e) => setSelected(e.target.value)}
              />
            </Col>
          </Row>

          {(isTyping || loading) && (
            <Row className="text-center">
              <Col xs={12}>
                <Spinner animation="border" variant="primary" />
              </Col>
            </Row>
          )}

          {!isTyping &&
            !loading &&
            typeof debouncedSearch === "string" &&
            debouncedSearch.trim().length > 0 &&
            debouncedSearch.trim().length < 3 && (
              <Row className="text-center">
                <Col xs={12}>
                  <p className="text-muted">Type at least 3 characters</p>
                </Col>
              </Row>
            )}

          {!isTyping &&
            !loading &&
            typeof debouncedSearch === "string" &&
            debouncedSearch.trim().length >= 3 &&
            filteredData.length === 0 && (
              <Row className="text-center">
                <Col xs={12}>
                  <NoData />
                </Col>
              </Row>
            )}

          {!isTyping && !loading && hasImage && filteredData.length > 0 && (
            <Row>
              {filteredData.map((item, key) => (
                <Col xs={12} md={6} key={key}>
                  <div
                    onClick={() => onSelect(item)}
                    className={`image-container-brand ${
                      debouncedSearch?.id === item.id ? "border-if-selected" : ""
                    }`}
                  >
                    <img
                      src={item.image.uri}
                      alt="image"
                      className="image-brand"
                    />
                    <p className="form-label">{item.title}</p>
                  </div>
                </Col>
              ))}
            </Row>
          )}

          {!isTyping && !loading && !hasImage && filteredData.length > 0 && (
            <Row>
              <Table striped bordered hover responsive>
                <tbody>
                  {filteredData.map((item, key) => (
                    <tr key={key} onClick={() => onSelect(item)}>
                      <td>{key + 1}</td>
                      <td>{item.title}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Row>
          )}
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default GridModal;
